import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HomeComponent } from './pages/home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SearchComponent } from './pages/search/search.component';
import { KpiComponent } from './pages/kpi/kpi.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { KpiAccessGuard } from './guards/kpi-access.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'prefix'
    },
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'search',
        component: SearchComponent,
        canActivate: [authGuard]
    },
    {
        path: 'policies',
        loadChildren: () => import('src/app/modules/policy/policy.module').then(m => m.PolicyModule)
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard]
    },
    {
        path: 'documents',
        component: DocumentsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'kpi',
        component: KpiComponent,
        canActivate: [KpiAccessGuard]
    },
    {
        path: 'not-found',
        component: NotFoundComponent
    },
    {
        path: '**',
        redirectTo: 'not-found'
    }
]

@NgModule({
    imports: [RouterModule.forRoot((routes), { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
